module.exports = __webpack_public_path__ + "static/media/icono_semola_am.7e1a8465.png";